module.exports = __webpack_public_path__ + "img/2-onebg.e9299d98.png";